export interface StoreHours {
    weekly: { [key: string]: StoreHoursData };
    exceptionalOpenings?: ExceptionalHoursData[];
    exceptionalClosings?: ExceptionalHoursData[];
}

export interface StoreHoursData {
    dayOpeningHours: string;
    dayName: string;
}

export interface ExceptionalHoursData {
    date: string;
    dayName: string;
    openingHours: string;
}

export enum MAP_LOCATION {
    LEFT = 'left',
    RIGHT = 'right',
}

export enum TAB_CHOICE {
    STORES = 'STORES',
    MAP = 'MAP',
}
